module.exports = __webpack_public_path__ + "img/6afdd309dca32a03e5fdc27294c180a9.svg";